import { withAuthenticator  } from '@aws-amplify/ui-react';
import { useHistory } from 'react-router';
import { Auth } from 'aws-amplify'
import { useEffect } from 'react';
const Login = ({ setUser }) => {
   const history = useHistory();
   useEffect(() => {
    if(Auth.user){
        setUser(Auth.user.username);
        history.push("/");
    }
   }, [history, setUser])
    return (
        <div className="home">
        </div>
    );
}
 
export default withAuthenticator(Login);